import type { AxiosResponse } from 'axios';

export interface TestResult {
  valid: boolean;
  response: Pick<AxiosResponse, 'data' | 'status' | 'statusText'> & { duration: number; helperText: string };
  requestData: string;
}

export interface WebhookHistory {
  product: {
    id: number;
    title: string;
  };
  customer: {
    name: string;
    email: string;
  };
  _id: string;
  producerId: number;
  type: WebhookTypes;
  payloadId: string;
  url: string;
  sentData: string;
  entityId: number;
  count?: number;
  entityStatus: number;
  sent_at: string;
  sends: Send[];
  updated_at: string;
  created_at: string;
  __v: number;
  urlId: string;
  lastSend: Send;
  status: string;
  event?: ContractEvents | InvoiceEvents | CartAbandonmentEvents;
}

export enum ContractEvents {
  contract_up_to_date = 'contract_up_to_date',
  contract_waiting_payment = 'contract_waiting_payment',
  contract_suspended = 'contract_suspended',
  contract_canceled = 'contract_canceled',
  contract_delayed = 'contract_delayed',
  contract_finished = 'contract_finished',
  contract_trial = 'contract_trial',
  contract_overdue = 'contract_overdue',
  contract_free = 'contract_free'
}

export enum InvoiceEvents {
  invoice_open = 'invoice_open',
  invoice_processing = 'invoice_processing',
  invoice_paid = 'invoice_paid',
  invoice_canceled = 'invoice_canceled',
  invoice_waiting_documents = 'invoice_waiting_documents',
  invoice_waiting_refund = 'invoice_waiting_refund',
  invoice_refunded = 'invoice_refunded',
  invoice_analysing = 'invoice_analysing',
  invoice_duplicated = 'invoice_duplicated',
  invoice_expired = 'invoice_expired',
  invoice_recovering = 'invoice_recovering',
  invoice_internal = 'invoice_internal',
  invoice_trial = 'invoice_trial',
  invoice_deleted = 'invoice_deleted',
  invoice_waiting_payment = 'invoice_waiting_payment',
  invoice_refused = 'invoice_refused',
  invoice_overdue = 'invoice_overdue',
  invoice_scheduled = 'invoice_scheduled',
  invoice_negociated = 'invoice_negociated'
}

enum CartAbandonmentEvents {
  cart_abandonment = 'cart_abandonment'
}

export enum WebhookType {
  invoice = 'invoice',
  abandonment = 'abandonment',
  contract = 'contract'
}

interface Send {
  url: string;
  payload_id: string;
  invoice_id: number;
  content_id: number;
  producer_id: number;
  returnData: string;
  returnStatus: string;
  status: boolean;
  deleted: boolean;
  _id: string;
  updated_at: string;
  created_at: string;
  __v: number;
}

export type WebhookTypes = 'invoice' | 'abandonment' | 'contract';
export interface Webhook {
  content_type: WebhookContentType;
  created_at: string;
  state: WebhookStatus;
  customer_id: number;
  deleted: boolean;
  description: string;
  internal: boolean;
  product_id: number[];
  product_name: string;
  status: boolean;
  type: WebhookTypes;
  updated_at: string;
  inQueueCount?: number;
  currentRetryingEvent?: string;
  url: string;
  __v: number;
  _id: string;
}

export interface WebhookHistoryFilter {
  date?: [string, string];
  product_id?: number[];
  customer?: string;
  entityId?: string;
  status?: string[];
  events: string[];
}

export interface WebhookFilter {
  url?: undefined | string;
  status?: string;
  type?: string;
}

export enum WebhookContentTypeAlias {
  json = 'application/json',
  urlencoded = 'application/x-www-form-urlencoded'
}

type WebhookContentType = 'application/json' | 'application/x-www-form-urlencoded' | '';

export interface FieldsWebHook {
  _id?: string;
  description: string;
  product_id: number[];
  url: string;
  type: WebhookTypes;
  content_type: WebhookContentType;
}

export enum WebhookStatus {
  active = 'active',
  failing = 'failing',
  inactive = 'inactive'
}
export enum WebhookTypeAlias {
  subscription = 'Contrato',
  invoice = 'Fatura',
  abandonment = 'Abandono de carrinho'
}

export enum WebhookStatusAlias {
  active = 'Ativo',
  failing = 'Erro na sua URL',
  inactive = 'Inativo'
}

export const InvoiceStatus = {
  1: 'Aberta',
  3: 'Paga',
  4: 'Cancelada',
  6: 'Aguardando Reembolso',
  7: 'Reembolsado',
  9: 'Duplicada',
  10: 'Expirada',
  11: 'Em recuperação',
  12: 'Aberta',
  13: 'Aberta',
  14: 'Aberta',
  15: 'Aguardando Pagamento',
  19: 'Negociada'
};

export const SubscriptionStatus = {
  1: 'Em Dia',
  2: 'Aguardando Pagamento',
  3: 'Suspenso',
  4: 'Cancelado',
  7: 'Atrasado',
  9: 'Finalizado',
  10: 'Trial',
  11: 'Inadimplente',
  19: 'Negociada'
};

export const WebhookTypes = [
  { label: 'Fatura', value: 'invoice' },
  { label: 'Abandono de carrinho', value: 'abandonment' }
];
